import React from 'react';
import { AdminHeader } from '../../../shared/components';
import ReservationList from './ReservationList';

const ReservationManagement = ({ adminData, onLogout }) => {
  const handleBackToDashboard = () => {
    // Navegar de vuelta al dashboard
    window.history.back();
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <AdminHeader
        adminData={adminData}
        onLogout={onLogout}
        showBackButton={true}
        onBackClick={handleBackToDashboard}
        backButtonText="Volver al Dashboard"
      />
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <ReservationList />
      </div>
    </div>
  );
};

export default ReservationManagement; 